/**
 * Waarden gelijk aan worker auth-register SIGNUP_SOURCES
 */
export const SIGNUP_SOURCE_OPTIONS = [
  { value: 'google', label: 'Google of andere zoekmachine' },
  { value: 'linkedin', label: 'LinkedIn' },
  { value: 'facebook_meta', label: 'Facebook of Instagram' },
  { value: 'youtube', label: 'YouTube' },
  { value: 'collega', label: 'Tip van een collega of zakelijke relatie' },
  { value: 'beurs_event', label: 'Beurs, seminar of ander evenement' },
  { value: 'nieuwsbrief_blog', label: 'Nieuwsbrief, blog of artikel' },
  { value: 'overig', label: 'Anders / weet ik niet meer' },
] as const;
